import { BackendClient, type BackendTypes } from '@tf/api';

export const getMonitoringAssociationsQuery = async (
	params: BackendTypes.EntityAssociationsGetParams,
): Promise<BackendTypes.EntityAssociationsGetData> => {
	const res = await BackendClient.getInstance().entityAssociationsGet(params);
	return res.json();
};
